import { personInfoFrag } from '../../../../../../utils/type/person.common-type';

export const operationalReportsFragment = `
    id
    serviceId
    dateFrom
    workData {
        ... on WorkDataOperationalReportObject {
            type
            description
            folders {
                id
                person {
                    ${personInfoFrag}
                }
            }
        }
    }
`;
